import React from 'react';

const Process = ({ t }) => {
  return (
    <section id="process" className="py-24 bg-slate-900">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {t.process.title}
          </h2>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto">
            {t.process.subtitle}
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative">
            {/* Vertical Line */}
            <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 h-full w-0.5 bg-slate-700"></div>

            {t.process.steps.map((step, index) => (
              <div
                key={index}
                className={`relative flex items-center mb-16 last:mb-0 ${
                  index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}
              >
                {/* Content */}
                <div className={`w-full md:w-5/12 ${index % 2 === 0 ? 'md:text-right md:pr-12' : 'md:text-left md:pl-12'}`}>
                  <div className="bg-slate-800/50 border border-slate-700 rounded-lg p-8 hover:bg-slate-800 transition-all duration-300 hover:scale-105">
                    <h3 className="text-3xl font-bold text-white mb-3">
                      {step.title}
                    </h3>
                    <p className="text-slate-400 text-lg leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>

                {/* Number Circle */}
                <div className="hidden md:flex absolute left-1/2 transform -translate-x-1/2 w-20 h-20 bg-slate-800 border-4 border-slate-700 rounded-full items-center justify-center z-10">
                  <span className="text-2xl font-bold text-white">
                    {step.number}
                  </span>
                </div>

                {/* Mobile Number */}
                <div className="md:hidden absolute -left-4 top-8 w-12 h-12 bg-slate-800 border-2 border-slate-700 rounded-full flex items-center justify-center">
                  <span className="text-lg font-bold text-white">
                    {step.number}
                  </span>
                </div>

                {/* Spacer */}
                <div className="hidden md:block w-5/12"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
